import React from 'react';
import get from 'lodash/get';
import { PageHeading } from '../../molecules/page-heading';
import { InfiniteStoryList } from '../../rows/infinite-story-list';

import '../../pages/tag/tag.m.css';

class TopicFull extends React.Component {
  render() {
    const params = {
      stories: get(this.props, ['data', 'stories']),
      baseApi: get(this.props, ['data', 'baseApi'], ''),
      fullWidthResult: true,
      hostImage: get(this.props, ['config', 'cdn-image'], '')
    };
    const heading =
      get(this.props, ['data', 'stories'], []).length > 0
        ? get(this.props, ['data', 'tagSlug'], '') + ' News'
        : 'No Results Found for the ' + get(this.props, ['data', 'tagSlug'], '');
    return (
      <div className="container">
        <div styleName="tag-story-list" className="row-section sidebar">
          <div>
            <PageHeading
              title={heading}
              hasStories={get(this.props, ['data', 'stories'], '').length > 0}
              count={get(this.props, ['data', 'total'], 0)}
            />
            <div styleName="infinite-container">
              <InfiniteStoryList {...params} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopicFull;
